import { type IPrivateContact } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IPrivateContactState } from './types';

export const GET_MATCHES = 'getMatches';

export const getters: GetterTree<IPrivateContactState, unknown> = {
    [GET_MATCHES]: (_state) => {
        return (contactId: number): IPrivateContact[] => {
            return _state.matches.get(contactId);
        };
    }
};
